document.addEventListener("DOMContentLoaded", () => {
    var filter_buttons = document.querySelectorAll(".collection-swiper-item .collection-wrapper");
    filter_buttons.forEach((item) => {
        var label = item.dataset.label;
        var tag_names = label.split(',');
        if(tag_names.length > 0){
            if(document.querySelector(`#FacetFiltersFormMobile collapsible-row[data-filter="tag"] input[value="${tag_names[0]}"]`) && document.querySelector(`#FacetFiltersFormMobile collapsible-row[data-filter="tag"] input[value="${tag_names[0]}"]`).checked){
                item.classList.add("filter-active");
            }
        }
        item.addEventListener("click", ()=> {
            var active_item = document.querySelector(".collection-swiper-item .collection-wrapper.filter-active");
            if(active_item){
                var active_label = active_item.dataset.label;
                var active_tag_names = active_label.split(',');
                if(active_tag_names.length > 0){
                    if(active_tag_names[1] == ""){
                        document.querySelector(`#FacetFiltersFormMobile collapsible-row[data-filter="tag"] input[value="${active_tag_names[0]}"]`)?.click();
                    }else {
                        active_tag_names.forEach((tag, index) => {
                            if(index == active_tag_names.length - 1){
                                document.querySelector(`#FacetFiltersFormMobile collapsible-row[data-filter="tag"] input[value="${active_tag_names[index]}"]`)?.click();
                                return;
                            }else {
                                document.querySelector(`#FacetFiltersFormMobile collapsible-row[data-filter="tag"] input[value="${active_tag_names[index]}"]`).checked = false;
                            }
                        })
                    }
                }
                active_item.classList.remove("filter-active");
            }
            if(tag_names.length > 0) {
                if(tag_names[1] == "") {
                    document.querySelector(`#FacetFiltersFormMobile collapsible-row[data-filter="tag"] input[value="${tag_names[0]}"]`)?.click();
                    if(document.querySelector(`#FacetFiltersFormMobile collapsible-row[data-filter="tag"] input[value="${tag_names[0]}"]`)?.checked){
                        item.classList.add("filter-active");
                    }else {
                        item.classList.remove("filter-active");
                    }
                }else {
                    var all_checked = false;
                    tag_names.forEach((tag_name, index) => {
                        if(index == tag_names.length - 1){
                            document.querySelector(`#FacetFiltersFormMobile collapsible-row[data-filter="tag"] input[value="${tag_names[index]}"]`).click();
                            return;
                        }else {
                            if(document.querySelector(`#FacetFiltersFormMobile collapsible-row[data-filter="tag"] input[value="${tag_names[index]}"]`).checked) {
                                document.querySelector(`#FacetFiltersFormMobile collapsible-row[data-filter="tag"] input[value="${tag_names[index]}"]`).checked = false;
                            }else {
                                document.querySelector(`#FacetFiltersFormMobile collapsible-row[data-filter="tag"] input[value="${tag_names[index]}"]`).checked = true;
                            }
                        }
                    });
                    tag_names.forEach((tag_name, index) => {
                        if(document.querySelector(`#FacetFiltersFormMobile collapsible-row[data-filter="tag"] input[value="${tag_names[index]}"]`).checked){
                            all_checked = true;
                        }else {
                            all_checked = false;
                        }
                    })
                    if(all_checked){
                        item.classList.add("filter-active");
                    }else {
                        item.classList.remove("filter-active");
                    }
                }
            }
        })
    })
})